import { InfoOutlined } from "@mui/icons-material";
import { Box, CircularProgress, IconButton } from "@mui/material";
import React from "react";

import { Typography } from "new-components/typography/Typography";


type ProjectedAccuracyMetricProps = {
  metric: string;
  value: string;
  onInfo: (value: boolean) => void;
  loading?: boolean;
};

function ProjectedAccuracyMetric({ metric, value, onInfo, loading }: ProjectedAccuracyMetricProps) {
  return (
    <Box m="auto 0" onClick={value ? () => onInfo(true) : () => {}} sx={{ cursor: "pointer" }}>
      <Box textAlign="end" whiteSpace="nowrap">
        <Typography noWrap textTransform="uppercase" color="white" variant="small">
          {metric}:
        </Typography>
        {value && (
          <IconButton size="small" sx={(theme) => ({ color: theme.palette.common.white })}>
            <InfoOutlined fontSize="inherit" />
          </IconButton>
        )}
      </Box>
      <Box display="flex" justifyContent="end" alignItems="center">
        <Typography
          noWrap
          color="white"
          fontWeight="bold"
          variant="subtitle"
          lineHeight={1}
          sx={{ opacity: value ? 1 : 0.7 }}
        >
          {value || "--.--%"}
        </Typography>
        {loading && <CircularProgress size={15} sx={{ color: "white", ml: 1 }} />}
      </Box>
    </Box>
  );
}

export default ProjectedAccuracyMetric;
